import { SVGProps } from "react";

export const BusinessChart3Icon = ({
  color = "currentColor",
  size = 16,
  strokeWidth = 1,
  ...rest
}: SVGProps<SVGSVGElement> & { size?: number }) => {
  /* Render */
  const render = () => (
    <svg width={size} height={size} {...rest} fill="none" viewBox="0 0 24 24">
      <path
        fill="none"
        d="m4.5 19.5 -3 1v3h3v-4Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill="none"
        d="m10.5 14.5 -3 1v8h3v-9Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill="none"
        d="m16.5 17 -3 1v5.5h3V17Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill="none"
        d="m22.5 10 -3 1v12.5h3V10Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M1.5 23.5h3v-2.001l-3 1V23.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M7.5 23.5h3v-7l-3 1v6Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M13.5 23.5h3V19l-3 1v3.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        fill={color}
        opacity={0.2}
        d="M19.5 23.5h3V12l-3 1v10.5Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m22 5.064 -1 -4.5 -4.5 1.5"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m3 12.064 6 -6 6 4.5 6 -10"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M0.5 23.5h23"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m4.5 19.5 -3 1v3h3v-4Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m10.5 14.5 -3 1v8h3v-9Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m16.5 17 -3 1v5.5h3V17Z"
        strokeWidth={strokeWidth}
      ></path>
      <path
        stroke={color}
        vectorEffect="non-scaling-stroke"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m22.5 10 -3 1v12.5h3V10Z"
        strokeWidth={strokeWidth}
      ></path>
    </svg>
  );
  return render();
};
